import { Component, OnInit, ViewChild } from '@angular/core';
import { MediaObserver } from '@angular/flex-layout';
import { MatSidenav } from '@angular/material/sidenav';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import * as globals from '../../globals';
import { AccountSelectorInputAsyncComponent } from '../../accounts/account-selector-input-async/account-selector-input-async.component';
import { Membership } from 'src/app/models/membership.model';
import { MatDialog } from '@angular/material/dialog';
import { ConfigurationsService } from 'src/app/services/configurations.service';
import { LoggingService } from 'src/app/services/logging.service';

interface AppType {
  value: string;
  viewValue: string;
}

@Component({
  standalone: false,
  selector: 'app-configurations-list',
  templateUrl: './configurations-list.component.html',
  styleUrl: './configurations-list.component.scss'
})
export class ConfigurationsListComponent implements OnInit {

  constructor(
    public media: MediaObserver,
    private configurationsService: ConfigurationsService,
    private logger: LoggingService,
    public dialog: MatDialog) { }

  ngOnInit(): void {
    this.isAdministrator = (localStorage.getItem(globals.POLICIES) === `${globals.TC}:${globals.trainingadmin}`);
  }

  private async updateEnvVariable(data: any) {
    this.configuration = data;
    this.sidenav.open();
  }

  private getEnvironmentVariables() {    
    try {
      this.loadingSpinner(true);
      if(this.selectedAppType === 'connect') {
        this.configurationsService.getConnectEnvVariables().subscribe({
          next: (data) => {
            this.dataSource = new MatTableDataSource(data);
            this.loadingSpinner(false);
          },
          error: (e) => {
            this.loadingSpinner(false);
            this.logger.logException(e);
          }
        });
      }
      else {
        this.configurationsService.getCdsEnvVariables().subscribe({
          next: (data) => {
            this.dataSource = new MatTableDataSource(data);
            this.loadingSpinner(false);
          },
          error: (e) => {
            this.loadingSpinner(false);
            this.logger.logException(e);
          }
        });
      }
    }
    catch (error) {
      this.logger.logException(error);
    }
  }

  onSelectionChange = (response) => this.getEnvironmentVariables();

  accountCleared = () => this.accountSelectorInputAsyncComponent.clear();

  variableUpdated = (response) => {
    this.logger.logEvent('Configurations Variable Updated', { appType: this.selectedAppType });
    this.getEnvironmentVariables();
  };

  variableCancelled = (response) => {
    this.configuration = {};
    this.getEnvironmentVariables();
  };

  isMobile = () => window.matchMedia('(max-width: 840px)').matches;

  loadingSpinner = (value: boolean) => this.isLoading = value;

  isAdministrator: boolean;
  isLoading: boolean;
  selectedAppType: string;
  configuration: any = {};
  dataSource = new MatTableDataSource<Membership>();
  displayedColumns: string[] = globals.configuration_columns;
  appTypes: AppType[] = [
    {value: 'connect', viewValue: 'Connect-Api'},
    {value: 'cds', viewValue: 'Cds-Api'}
  ];
  
  @ViewChild(AccountSelectorInputAsyncComponent, { static: false }) accountSelectorInputAsyncComponent: AccountSelectorInputAsyncComponent;
  @ViewChild('sidenav') sidenav: MatSidenav;
  @ViewChild(MatSort) set matSort(sort: MatSort) {
    this.dataSource.sort = sort;
  }

}
